import { FC, ChangeEvent, KeyboardEvent, useEffect, useState } from 'react'
import styled from 'styled-components'
import { KeyEvent } from '@/core/global'

type TextInputProps = {
  value: string
  placeholder: string
  hideBorder?: boolean
  onTextChanged?: (text: string) => void
  onBlur?: (text: string) => void
} & Rest

const TextInput: FC<TextInputProps> = ({
  placeholder,
  value,
  onTextChanged,
  onBlur,
  hideBorder,
  ...rest
}) => {
  const [text, setText] = useState<string>(value)
  useEffect(() => {
    setText(value)
  }, [value, onBlur])
  const handleKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === KeyEvent.Enter) {
      e.currentTarget.blur()
      value = ''
      onBlur && onBlur(text)
    }
  }
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value
    onTextChanged ? onTextChanged(text) : setText(text)
  }
  return (
    <StyledInput
      hideBorder={hideBorder}
      placeholder={placeholder}
      value={text}
      onKeyDown={handleKeyUp}
      onChange={handleOnChange}
      onBlur={() => onBlur && onBlur(text)}
      {...rest}
    />
  )
}

export default TextInput

const StyledInput = styled.input`
  border: ${(props) =>
    props.hideBorder ? 'none' : `1px solid ${props.theme.colors.onBackground}`};
  border-radius: ${(props) => props.theme.borderRadius}px;
  padding: 12px 13px;
  width: 100%;
  &:focus {
    outline-width: 0;
  }
  ::placeholder {
    color: ${(props) => props.theme.colors.placeholder};
  }

  :-ms-input-placeholder {
    color: ${(props) => props.theme.colors.placeholder};
  }

  ::-ms-input-placeholder {
    color: ${(props) => props.theme.colors.placeholder};
  }
`
